<template>
  <div class="pannel05">
    <div style="border-bottom:1px solid #ccc;font:700 12px/40px 'simsun';padding-left: 10px">用户地区分布</div>
    <div id="pie_show5" class="pie_show5"></div>
  </div>
</template>

<script>
import cons from '@/components/constant'
export default {
  name: 'PieGraph',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    let token = localStorage.token;
    let oPie = this.echarts.init(document.getElementById('pie_show5'));
    let pro01 = new Promise((resolve,reject)=>{
        this.axios.get(cons.apis + '/v1_0/statistics_read_source_total', {
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType: 'json'
          })
          .then(dat=>{
              resolve(dat);
          }).catch(err=>{
             reject(dat);
        });
    });


    async function fnFinish(){
      let rs01 = await pro01;
      // let rs02 = await pro02;
      // console.log([rs01,rs02]);

      // {value:rs02.data.count, name:'下单用户'},
      // {value:1, name:'北京'+" 10%"+" ¥ 4553"},
      let arr = []
      var num = 0
      var num2 = 0
      for(var i=0;i<rs01.data.data.read_sources.length;i++){
        if(rs01.data.data.read_sources[i].source_name == '其他' ||rs01.data.data.read_sources[i].source_name == '推荐' ||rs01.data.data.read_sources[i].source_name == '频道' ){
          num = (rs01.data.data.read_sources[i].count/rs01.data.data.total_read_count*100).toFixed(2)
          num *= 1
          if(rs01.data.data.read_sources[i].source_name == '其他'){
            num = 100 - num2
          }
          num2 += num
          arr.push({
            value: rs01.data.data.read_sources[i].count,
            name: rs01.data.data.read_sources[i].source_name+" "+num+"%"+" ¥ "+rs01.data.data.read_sources[i].count,
          })
        }

      }



      var oPieopt =
        {
          title : {
              top:10,
              text: '阅读来源分析(只计算推荐和频道的阅读)',
              x:'center'
          },
          tooltip : {
              trigger: 'item',
              formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          // color:['#ffcb5b','#ff6666','skyblue','yellowgreen'],
          // legend: {
          //     x : 'center',
          //     top:65,
          //     // data:['日活用户','下单用户']
          //     // data:['北京','上海','广州','深圳']
          // },
          toolbox: {
              show : true,
              x : 'center',
              top:35,
              feature : {
                  mark : {show: true},
                  dataView : {show: true, readOnly: false},
                  magicType : {
                      show: true,
                      type: ['pie', 'funnel'],
                      option: {
                          funnel: {
                              x: '25%',
                              width: '50%',
                              funnelAlign: 'left',
                              max: 1548
                          }
                      }
                  },
                  restore : {show: true},
                  saveAsImage : {show: true}
              }
          },
          calculable : true,
          series : [
              {
                  name:'访问来源',
                  type:'pie',
                  radius : '55%',
                  center: ['50%', '60%'],
                  data: arr
                  // data:[
                  //     // {value:rs01.data.count, name:'日活用户'},
                  //     // {value:rs02.data.count, name:'下单用户'},
                  //     {value:1, name:'北京'+" 10%"+" ¥ 4553"},
                  //     {value:2, name:'上海'+" 20%"+" ¥ 4553"},
                  //     {value:3, name:'广州'+" 30%"+" ¥ 4553"},
                  //     {value:4, name:'深圳'+" 40%"+" ¥ 4553"},
                  // ]
              }
          ]
      };

      oPie.setOption(oPieopt);
    }

    fnFinish();
  }
}
</script>

<style scoped>
.pannel05{
  width: 46.3%;
  height:500px;
  margin:20px auto 0;
  background-color:#fff;
  float:left;
  margin-left:2.4%;
}
.pie_show5{
  width:100%;
  height:350px;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/PieGraphThree.vue